import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TsFilterListItemComponent } from './ts-filter-list-item.component';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TsPipesModule } from '../cross-cutting/pipes/ts-pipes.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TsButtonModule } from '../ts-button';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { MatIconModule } from '@angular/material/icon';
import { TsSelectModule } from '../ts-select/ts.select.module';
import { TsOverlayModule } from '../ts-overlay';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { FieldStylingDirective } from '../../lib/directives';

@NgModule({
  declarations: [TsFilterListItemComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    TsPipesModule,
    TsButtonModule,
    CurrencyMaskModule,
    MatIconModule,
    TsSelectModule,
    TsOverlayModule,
    MatDatepickerModule,
    MatProgressSpinnerModule,
    NgxMaskDirective,
    NgxMaskPipe,
    FieldStylingDirective,
  ],
  exports: [TsFilterListItemComponent],
  providers: [provideNgxMask()],
})
export class TsFilterListItemModule {}
